import { SwipeableDrawer, IconButton, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import * as OnboardEntity from '../../../Entities/OnBoardingContainerTypes'
import Box from '@mui/material/Box'
import { IoIosCloseCircleOutline } from 'react-icons/io'

export default function ViewRejectComments ({ isViewComments, setIsViewComments, comments }) {
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const [ viewComments, setViewComments ] = useState(null)
    useEffect(() => {
        setViewComments(comments)
    }, [comments])
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        setIsViewComments({ ...isViewComments, [anchor]: open })
    }

    const list = () => (
        <Box className="p-4 h-[100%]">
            <Box className="p-3 flex justify-between items-center border-b-2 border-[hsl(var(--primary-table-head))]">
                <h2 className="text-xl font-bold text-primary">{'Comments'}</h2>
                <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                    <IconButton onClick={() => setIsViewComments({ right: false })} aria-label="close">
                        <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                    </IconButton>
                </Tooltip>
            </Box>
            <div className='flex mt-3 flex-col h-[90%]'>
                <div className='flex flex-col mt-4'>
                    <p className='font-bold pb-2'>
                        <span className='text-muted'>{viewComments}</span>
                    </p>
                </div>
            </div>
        </Box>
    )
    return (
        <>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={isViewComments?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list()}
            </SwipeableDrawer>
        </>
    )
}
